import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';

async function fetchItineraryDescription(data, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/ai/itinerary-description`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(data)
    });
    return response;
}

export default function useItineraryAiDescription(options) {
    return useAuthMutation({
        mutationFn: fetchItineraryDescription,
        mutationKey: ['aiDescription'],
        ...options
    });
}
